import { useQuery } from '@tanstack/react-query';

import { getAccountDetails } from '~/services/ContractingService';

import { accountQueryKeys } from './accountQueryKeys';
import { retryUnlessRejected } from './retryUnlessRejected';

export function useGetAccountDetails(accountId: string | undefined) {
  return useQuery({
    queryKey: accountQueryKeys.details(accountId ?? ''),
    queryFn: ({ signal }) => getAccountDetails(accountId ?? '', { signal }),
    enabled: !!accountId,
    retry: retryUnlessRejected,
  });
}
